import { Button, message } from 'antd';
import '../../assets/scss/pages/auth.scss';
import { User } from '../../actions';
import { useState } from 'react';
export const EmailRequiredPage: React.FC = () => {
    const email = window.localStorage.getItem("email");
    const [isSendingEmail, setSendingEmail] = useState<boolean>(false);
    const onClickResendVerifyEmail = async () => {
        const closeLoading = message.loading(`We are sending verify email to ${email}. Just a second...`);
        setSendingEmail(true);
        try {
            if (email) {
                const response = await User.resendVerifyEmail(email);
                if (response.status) message.success(`Email sent to ${email}. Please check your inbox`, 3);
                else message.warning(response.message, 3);
            }
            else message.error(`invalid email address`);
        } catch (error) {
            console.log(error);
        }
        setSendingEmail(false);
        closeLoading();
    };

    return (
        <>
            <div className="page page-email-required">
                <div className="body-section">
                    <div className="row-title">
                        Verify your email to proceed
                    </div>
                    <div className="row-desc">
                        We just sent an email to the address: <strong>{email}</strong><br />
                        Please check your email and click on the link provided to verify your address.
                    </div>
                    <div className='tw-mt-4'>
                        <Button 
                            type="primary" 
                            onClick={onClickResendVerifyEmail} 
                            disabled={isSendingEmail}
                            loading={isSendingEmail}
                        >Resend Verification Email  </Button>
                    </div>
                </div>
            </div>
        </>
    );
};